'use client';

import { useState, type FC } from 'react';
import type { AlertProps } from './alerts.types';
import { FloatingAlert } from './floating-alert';
import { FullWidthAlert } from './full-width-alert';

export { alertColorVariants } from './alerts.constants';

export const Alert: FC<AlertProps> = ({
  size = 'floating',
  defaultOpen = true,
  ...props
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  if (!isOpen) {
    return null;
  }

  if (size === 'full-width') {
    return (
      <FullWidthAlert
        onClose={() => {
          props.onClose?.();
          setIsOpen(false);
        }}
        onDismiss={() => {
          props.onDismiss?.();
          setIsOpen(false);
        }}
        {...props}
      />
    );
  }
  return (
    <FloatingAlert
      onClose={() => {
        props.onClose?.();
        setIsOpen(false);
      }}
      onDismiss={() => {
        props.onDismiss?.();
        setIsOpen(false);
      }}
      {...props}
    />
  );
};
